<template>
  <ContactTracingTable />
</template>

<script>
import ContactTracingTable from "@/v3components/Datatables/ContactTracingTable"
export default {
  name: "ContactTracing",
  components: { ContactTracingTable }
}
</script>
